const countdown = (startTime) => {
    // Get today's date and time
    let now = new Date().getTime()

    // Find the distance between now and the count down date
    let distance = startTime - now

    // Time calculations for minutes and seconds
    let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
    let seconds = Math.floor((distance % (1000 * 60)) / 1000)

    // If the count down is finished
    if (distance < 0) {
        return 'expired'
    } else {
        return {
            minutes,
            seconds,
            hours,
        }
    }
}

export default countdown
